<template>
  <b-modal
    ref="modal"
    :visible="visible"
    @hidden="onHidden"
    id="speaker-request-modal"
    centered
    hide-header
    hide-footer
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    body-class="p-0"
    content-class="speaker-request-modal-content"
  >
    <div class="modal-body-content">
      <h4 class="modal-title">Katılma isteği</h4>
      <p v-if="request" class="modal-text">
        "{{ request.userName }}" Kullanıcısı yayına katılmak istiyor.
      </p>
      <p v-else class="modal-text">
        İstek bilgisi yükleniyor...
      </p>
      <div class="modal-actions">
        <b-button variant="success" class="accept-button" @click="handleAccept" :disabled="!request">
          İzin ver
        </b-button>
        <b-button variant="secondary" class="reject-button" @click="handleReject" :disabled="!request">
          Reddet
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'

export default {
  name: 'SpeakerRequestModal',
  components: {
    BModal,
    BButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    request: {
      type: Object,
      default: null,
    },
  },
  methods: {
    handleAccept() {
      if (this.request && this.request.userId) {
        this.$emit('accept', this.request.userId);
      }
    },
    handleReject() {
      if (this.request && this.request.userId) {
        this.$emit('reject', this.request.userId);
      }
    },
    showModal() {
      if (this.$refs.modal) {
        this.$refs.modal.show();
      }
    },
    hideModal() {
      if (this.$refs.modal) {
        this.$refs.modal.hide();
      }
    },
    onHidden() {
      this.$emit('update:visible', false);
    },
  },
}
</script>

<style lang="scss" scoped>
.speaker-request-modal-content {
  border-radius: 16px !important;
  border: none;
}

.modal-body-content {
  padding: 30px;
  text-align: center;
  background-color: #ffffff;
  border-radius: 16px;
  color: #333; // Darker text color for better contrast
}

.modal-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #000; // Black title
}

.modal-text {
  font-size: 16px;
  margin-bottom: 25px;
  color: #555; // Slightly darker gray for text

  // Make username bold
  span {
    font-weight: 600;
  }
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 15px;

  .accept-button {
    background-color: #10d876 !important; // Brighter green from image
    border-color: #10d876 !important;
    color: white;
    font-weight: 600;
    padding: 12px 30px;
    border-radius: 25px;
    flex-grow: 1; // Allow buttons to grow
    max-width: 180px; // Max width for buttons
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #0ebf65 !important; // Darker green on hover
      border-color: #0ebf65 !important;
    }
    &:disabled {
       background-color: #cccccc !important;
       border-color: #cccccc !important;
    }
  }

  .reject-button {
    background-color: #e0e0e0 !important; // Light gray from image
    border-color: #e0e0e0 !important;
    color: #757575; // Darker gray text
    font-weight: 600;
    padding: 12px 30px;
    border-radius: 25px;
    flex-grow: 1;
    max-width: 180px;
    transition: background-color 0.2s ease;


    &:hover {
      background-color: #d1d1d1 !important; // Darker gray on hover
      border-color: #d1d1d1 !important;
    }
     &:disabled {
       background-color: #cccccc !important;
       border-color: #cccccc !important;
       color: #a0a0a0;
    }
  }
}


</style> 